import { NotFound } from 'components/common/NotFound';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import StoreSettingDetailPage from './pages/StoreSettingDetailPage';
import StoreSettingPage from './pages/StoreSettingPage';

function StoreFeature() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/store-setting`} />
      </Route>
      <Route path={`${path}/store-setting/:restaurantId`}>
        <StoreSettingDetailPage />
      </Route>
      <Route path={`${path}/store-setting`}>
        <StoreSettingPage />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default StoreFeature;
